<template>
    <div class="ali_oss">
         <el-form :model="ruleForm[index]" :ref="ruleForm[index]" label-width="10vw" class="ruleForm" v-for="(item,index) in ruleForm" :key="index">
            <el-form-item :label="item.name" prop="value">
                <el-input v-model="ruleForm[index].value"></el-input>
            </el-form-item>
        </el-form>
        <div class="opDiv">
            <AppButton type="primary" @click="submit" size="small">提交</AppButton>
            <AppButton @click="reset" size="small">重置</AppButton>
        </div>
    </div>
</template>

<script>
import { ConfigService } from '@/service/config.service'
export default {
    data() {
        return {
            ruleForm:[],
        }
    },
    methods: {
        async getList() {
            const data = await ConfigService.getList('ali_oss')
            this.ruleForm = data
        },
        async submit() {
            await ConfigService.editConfig(this.ruleForm)
            this.getList()
            //axios.post('https://api.goodyiyao.cn/api/config/editConfig',qs.stringify(this.ruleForm,{indices: false}))
        },
        async reset() {
           const data = await ConfigService.getList('ali_oss')
           this.ruleForm = data 
        }
    },
    created() {
        this.getList()
    }
}
</script>

<style lang="scss">
    .ali_oss{
        .opDiv{
            display: flex;
            text-align: center;
            justify-content: center;
            .el-button--small{
            }
        }
        
    }
</style>